import { FormattedMessage } from '@alltrails/shared/react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import { LanguageSupportUtil } from 'utils/language_support_util';
import { lazy, Suspense } from 'react';
import { NoSsr } from '@material-ui/core';
import { MEDIA_QUERY_SMALL_DOWN } from 'utils/constants/breakpoints';
import * as styles from './styles/styles.module.scss';
import upgradeImg from './images/Upgrade.avif';
import upgradeMobileImg from './images/Upgrade-M.avif';

// Designs: https://www.figma.com/design/SLeQY3u3PIQLGina96uVji/2025-Web-Pages?node-id=6982-1924&m=dev

const LogoMorph = lazy(() => import('components/shared/LogoMorph'));

type Props = {
  windowWidth: number;
};

const BREAKPOINT_MD = 1120;

const UpgradeYourAdventures = ({ windowWidth }: Props): JSX.Element => {
  const languageRegionCode = useLanguageRegionCode();
  const ctaButtonSize = windowWidth <= BREAKPOINT_MD ? 'sm' : 'md';

  return (
    <div className={styles.outerContainer}>
      <div className={styles.container}>
        <div className={styles.contentAndImageContainer}>
          <picture>
            <source srcSet={upgradeMobileImg} media={MEDIA_QUERY_SMALL_DOWN} type="image/avif" />
            <img src={upgradeImg} alt="" className={styles.image} />
          </picture>

          <div className={styles.imageOverlay}>
            <div className={styles.content}>
              <div className={styles.logoAnimation}>
                <NoSsr>
                  <Suspense fallback={null}>
                    <LogoMorph />
                  </Suspense>
                </NoSsr>
              </div>
              <h2 className={styles.header}>
                <FormattedMessage defaultMessage="Upgrade your adventures" />
              </h2>
              <div className={styles.subText}>
                <FormattedMessage defaultMessage="Whether you want to explore offline or create your own route, choose the membership that helps you make the most of every minute outdoors." />
              </div>
              <Button
                allowWrap
                text={<FormattedMessage defaultMessage="Compare plans" />}
                linkInfo={{ href: LanguageSupportUtil.wrapUrlSafe('/plus', languageRegionCode) }}
                testId="upgrade-your-adventures-button"
                variant="accent"
                size={ctaButtonSize}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeYourAdventures;
